var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check_tag_item"},[_c('span',{class:{ 'cursor-pointer':true,'is_checked':_vm.isChecked},on:{"click":_vm.handleItemClick}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }